"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/DashboardCard/index.js";
var defaultProps = {
  className: "bg-white",
  icon: "bi bi-people",
  value: "0",
  label: "TOTAL",
  labelAction: "VIEW"
};
function DashboardCard(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    labelAction = _ref.labelAction,
    onClick = _ref.onClick,
    loading = _ref.loading;
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    count = _React$useState2[0],
    setCount = _React$useState2[1];
  _react["default"].useEffect(function () {
    var start = 0;
    var end = parseInt(value);
    var duration = 1000; // Animation duration in milliseconds
    var increment = Math.ceil(end / (duration / 10));
    var timer = setInterval(function () {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 10);
    return function () {
      clearInterval(timer); // Clean up the timer when component unmounts
    };
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classNames["default"])(className, "shadow-sm bg-white p-3 p-lg-4 rounded"),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fs-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 19
    }
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 17
    }
  }, count.toLocaleString())), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-end",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "m-0 text-truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 17
    }
  }, label)), /*#__PURE__*/_react["default"].createElement("hr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 13
    }
  }), loading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 21
    }
  }) : /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClick,
    className: "btn btn-link p-0 w-100 d-flex justify-content-between text-uppercase text-truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 21
    }
  }, labelAction, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-arrow-right",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 25
    }
  })));
}
DashboardCard.defaultProps = defaultProps;
var _default = exports["default"] = DashboardCard;